import React, { Fragment, useEffect, useState } from 'react';
import Comment from './Comment';
import Swal from 'sweetalert2';
import { Toast } from '../UI/toast/Toast';
import { deleteComment } from '../../helpers/api/post';
import { SUCCESS_RESPONSE } from '../../helpers/codeResponses/codes';
import handleErrorMessage from '../../helpers/errors/handleErrorMessage';

const Comments = React.memo(({ comments }) => {

    const [_comments, _setComments] = useState(comments);

    let filter = [];

    useEffect(() => {
        _setComments(comments);
    }, [comments]);

    const dropComment = (id) => {
        Swal.fire({
            title: 'Seguro quieres eliminar este comentario?',
            showDenyButton: true,
            showCancelButton: true,
            confirmButtonText: `Si, eliminar`,
            cancelButtonText: 'no, dejar',
        }).then(async (result) => {
            if (result.value) {
                await deleteComment(id)
                    .then(({ code }) => {
                        if (code === SUCCESS_RESPONSE.OK) {

                            _comments.map(item => (item.id !== id) && filter.push(item));
                            _setComments(filter);

                            Toast.fire({ title: 'Comentario eliminado', type: 'success' });
                        }
                    })
                    .catch(error => handleErrorMessage(error));
            }
        })
    }

    return <Fragment>
        {_comments.map(({ id, author: { firstname, lastname, image }, commnet }) =>
            <Comment
                id={id}
                key={id}
                dropComment={dropComment}
                author={{ firstname, lastname, image }}
                commnet={commnet}
            />)}
    </Fragment>
})

export default Comments;